import { FOLDER_COLORS, VALID_FOLDER_COLORS } from "../constants";
import { FolderColor } from "../types";

export function isValidFolderColor(color: unknown): boolean {
  return typeof color === "string" && (VALID_FOLDER_COLORS as string[]).includes(color);
}

export function normalizeFolderColor(color: unknown): FolderColor {
  if (isValidFolderColor(color)) {
    return color as FolderColor;
  }
  // Default to blue if color is invalid
  return "blue";
}

export function getFolderColorClassName(color: FolderColor | null) {
  return color && isValidFolderColor(color) ? FOLDER_COLORS[color].fgClass : undefined;
}
